import dateFns from 'date-fns';

const TEMPLATE_NAME = 'WEEK_VISITS';

const formatData = data => {
    return data.map(elem => {
        let { start: startVisit, end: endVisit, arrivalDate } = elem

        const doesStartVisitExist = !!startVisit
        const doesEndVisitExist = !!endVisit

        if (doesStartVisitExist && !doesEndVisitExist) {
            endVisit = startVisit
        }

        if (!doesStartVisitExist && doesEndVisitExist) {
            startVisit = endVisit
        }

        const hours = dateFns.getHours(new Date(arrivalDate))
        const minutes = dateFns.getHours(new Date(arrivalDate))
        const arrivalTimeIsMidnight = hours === 0 && minutes === 0

        if (arrivalTimeIsMidnight) {

            arrivalDate = dateFns.addSeconds(new Date(arrivalDate), 1)

        } else {

            arrivalDate = new Date(arrivalDate)

        }

        return {
            ...elem,
            start: doesStartVisitExist? new Date(startVisit) : dateFns.addSeconds(new Date(arrivalDate), 1),
            end: doesEndVisitExist ? new Date(endVisit) : dateFns.addSeconds(new Date(arrivalDate), 1)
        }
    })
}

const initialState = () => ({
    loading: false,
    data: []
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;

            return {
                ...state,
                loading: false,
                data: formatData(data)
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};

export default reducer;
